import genID from "./random";
import mediaUpInit from "./mediaUpInit";
function mediaAllInit(){
  const WRAPPER = '.media-wrapper'
  $(WRAPPER).each(function (){
    new mediaUpInit(this)
  })
}

export default mediaAllInit
